export const mbonusDepatments : { value: string; label: string }[] = [
  { value: 'partners_network', label: 'Отдел развития партнёрской сети' },
  { value: 'sales_b2b', label: 'Отдел продаж B2B' },
  { value: 'sales_b2c', label: 'Отдел продаж B2C' },
  { value: 'installment_development', label: 'Отдел развития рассрочки' },
  { value: 'corporate_sales', label: 'Управление корпоративных продаж' },
  { value: 'regional_managers', label: 'Управление региональных менеджеров' },
  { value: 'project_office', label: 'Проектный офис' },
]
